import './Services.scss';
// Components
import Header from "../components/Header/Header";
import PlansInfo from "../components/PlansInfo/PlansInfo";
import Accordions from "../components/Accordions/Accordions";
import Footer from "../components/Footer/Footer";
import Wppbtn from '../components/Wppbtn/Wppbtn';
import Image from '../components/Image/Image';
// Data
import frequentQuestions from '../data/frequent-questions.json'
import Plans from '../data/meal-plans.json'
// Metadata Component 
import MetaTags from '../components/MetaTags/MetaTags';
// Image
import image from '../assets/images/medidas.webp';

function Services() {
  return (
    <div className="services">
      <MetaTags
        title='Licenciada en Nutrición Belén Olivera | Servicios'
        description='Descubre nuestros servicios de nutrición personalizados. Ofrecemos medidas antropométricas, consultas personalizadas y diferentes planes que se adapten a tus necesidades. ¡Hagamos de tu bienestar una prioridad y comencemos esta transformación juntos!'
        image='images/logotipo-white-desktop.png'
        name='Lautaro Tamborindeguy'
      />
      <Header />
      <div className='container'>
        <div className='title'>
          <h1>Servicios</h1>
          <p>Este puede ser el último plan que empieces… y el primero que puedas mantener.</p>
        </div>
      </div>
      <main className='container'>
        {Plans.plans.map((plan, idx) => (
          <PlansInfo
            key={idx}
            title={plan.title}
            subtitle={plan.subtitle}
            text={plan.text}
            image={plan.image}
            support={plan.support}
            price={plan.price}
          />
        ))}
      </main>
      <section className='container'>
        <div className={`plansInfo`} id="medidas-antropometricas">
          <Image webpDesktopSrc={image} webpMobileSrc={image} width={'400'} loading={'lazy'} alt={'Medidas Antropométricas'} className='plansInfo__image' />
          <div className='plansInfo__content medidas'>
            <div className='plansInfo__content__title'>
              <h3>¿Te gustaría tener una evaluación más exhaustiva de tu progreso?</h3>
              <h2>Medidas Antropométricas</h2>
            </div>
            <p className='plansInfo__content__text'>Si querés llevar un registro más completo de tu progreso, podés sumar al plan que elijas un análisis detallado de tu composición corporal (masa muscular, grasa, agua corporal, medidas, etc.).</p>
            <p className='plansInfo__content__text medidas'>Opciones y valores:</p>
            <ul className='plansInfo__content__list medidas'>
              <li>Extra en tu plan mensual: $1000 adicionales por mes</li>
              <li>Solo este servicio: $1500</li>
            </ul>
            <p className='plansInfo__content__text'>Este análisis te permite ver cambios que no siempre se reflejan en la balanza y ajustar tu plan de forma más precisa.</p>
          </div>
        </div>
      </section>
      <section className='container'>
        <h2>Preguntas Frecuentes</h2>
        <Accordions data={frequentQuestions.questions}/>
      </section>
      <Footer />
      <Wppbtn />
    </div>
  );
}

export default Services;